<template>
<div class="kt-widget__item"> 
    <div class="kt-widget__icon">
        <slot name="icon"></slot>
    </div>
    <div class="kt-widget__details">
        <slot name="detail"></slot>
    </div>
</div>
</template>

<script>
export default {

}
</script>